<script lang="ts" setup>
const props = defineProps<{
  userId?: number
  auth?: User.Auth
  src?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xl2' | 'xl3'
  disableJump?: boolean
}>()

const img404 = 'https://resource.mfuns.net/imgs/placeholder/default_avatar.webp'
const url = resizeImg(props.src ?? '', 160)

function onClick(e: Event) {
  if (props.disableJump) return
  if (props.userId) {
    open(`/member/${props.userId}`)
  }
}
</script>

<template>
  <div :key="src" class="mf-avatar-wrap">
    <img
      :key="url"
      :src="
        url || 'https://resource.mfuns.net/imgs/placeholder/default_avatar.webp'
      "
      :class="size || 'md'"
      :onerror="`this.onerror=null;this.src='${img404}'`"
      class="mf-avatar preview"
      alt="avatar"
      @click="onClick"
    />
    <img
      v-if="auth"
      :src="`https://resource.mfuns.net/imgs/auth/${auth.type}.svg`"
      alt="auth"
      class="mf-auth"
      :class="size || 'md'"
    />
  </div>
</template>

<style lang="scss" scoped>
.mf-avatar-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.mf-avatar {
  cursor: pointer;
  object-fit: cover;
}
.mf-avatar.xs {
  width: 24px;
  height: 24px;
  border-radius: 12px;
}
.mf-avatar.sm {
  width: 30px;
  height: 30px;
  border-radius: 15px;
}
.mf-avatar.md {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}
.mf-avatar.lg {
  width: 60px;
  height: 60px;
  border-radius: 30px;
}
.mf-avatar.xl {
  width: 80px;
  height: 80px;
  border-radius: 40px;
}
.mf-avatar.xl2 {
  width: 100px;
  height: 100px;
  border-radius: 50px;
}
.mf-avatar.xl3 {
  width: 120px;
  height: 120px;
  border-radius: 60px;
}
.mf-auth {
  position: absolute;
  background: #fff;
  border-radius: 50%;
  outline: 2px solid #fff;
  bottom: 0;
  right: 0;
  z-index: 100;
}
.mf-auth.xs {
  width: 8px;
  height: 8px;
  outline: none;
}
.mf-auth.sm {
  width: 12px;
  height: 12px;
}
.mf-auth.md {
  width: 16px;
  height: 16px;
}
.mf-auth.lg {
  width: 18px;
  height: 18px;
}
.mf-auth.xl {
  width: 24px;
  height: 24px;
}
.mf-auth.xl2 {
  width: 20px;
  height: 20px;
  bottom: 6px;
  right: 6px;
}
.mf-auth.xl3 {
  width: 30px;
  height: 30px;
  bottom: 0px;
  right: 0px;
}
</style>
